import React from 'react';
import { observer } from 'mobx-react';
import { FilterSelect } from './FilterSelect';
import { IFilterParams, IFilterSelectComposed, SelectType } from '../../../interfaces';
import {
    useOriginalUnitTypeSelect,
    useUiUnitTypeValue,
    useUiUnitTypeValues,
    useVisibleOriginalUnitTypeSelect,
} from '../../../hooks';
import { UnitTypeValues } from '../../../middleware';
import { tI } from '../../../translate';
import { Catcher } from '../../Catcher';

type IFilterOriginalUnitTypes = {
    filterParams: IFilterParams;
    isBlockAllowClear?: boolean;
    isUseVisible?: boolean;
    onChange: (ids: IFilterSelectComposed) => void;
    value?: UnitTypeValues;
};
export const FilterOriginalUnitTypes: React.FC<IFilterOriginalUnitTypes> = observer(
    ({ filterParams, isBlockAllowClear, isUseVisible, onChange, value }: IFilterOriginalUnitTypes) => {
        const unitTypes = filterParams?.unitTypes === SelectType.SINGLE ? useUiUnitTypeValue() : useUiUnitTypeValues();

        const onChangeUnitTypes = (ids: IFilterSelectComposed): void => {
            onChange(ids || filterParams.defaultUnitTypes);
        };

        return (
            <Catcher>
                <FilterSelect
                    idSpinners={['GET_ORIGINAL_UNIT_TYPE_SELECT']}
                    isBlockAllowClear={isBlockAllowClear || filterParams.isUnitTypesBlockClear}
                    mode={filterParams?.unitTypes}
                    onChange={onChangeUnitTypes}
                    title={tI('Unit Type Filter')}
                    useSelectHook={isUseVisible ? useVisibleOriginalUnitTypeSelect : useOriginalUnitTypeSelect}
                    value={value || unitTypes}
                />
            </Catcher>
        );
    },
);
